// extracted by mini-css-extract-plugin
export default {"container":"activity_details_actions-module___container___c2af2eb8"};